export default __webpack_public_path__ + "static/media/arrow-up-down.3516c17e.svg";